import { isUrl } from '../../utility/utility';

export const isValidTikTokAudioIdentifier = (identifier: string) => {
    if (isUrl(identifier)) {
        return isTiktokMusicUrl(identifier);
    }

    return /^\d*$/.test(identifier);
};

export const isTiktokMusicUrl = (url: string) => {
    const regex = /^(https?:\/\/)?(www\.)?tiktok\.com\/music\/[A-Za-z0-9\-_']+\/?(\?.*)?$/;
    return regex.test(url);
};

const sanitizeTiktokUrl = (url: string) => {
    let sanitizedUrl = url;

    if (url.includes('?')) {
        sanitizedUrl = url.split('?')[0];
    }

    return sanitizedUrl;
};

const getIdPathFromUrl = (url: string) => {
    const sanitizedUrl = sanitizeTiktokUrl(url);
    return sanitizedUrl.split('/').pop() ?? '';
};

export const getTikTokAudioIdFromUrl = (url: string) => {
    return getIdPathFromUrl(url).replace(/[^0-9]/g, '');
};
